import type { DropDownNoSelection, DropDownResult, HfDynamicFieldComponentProps } from '@myosh/odin-components';
import { OdinController } from '@myosh/odin-components';
import type { TrainingFieldProps } from './training-field.component';
import TrainingField from './training-field.component';

export default function HfTrainingField({
  name,
  control,
  label,
  value,
  readOnly,
  required,
  formId,
  onChange,
  id,
  setFieldValue,
  setFormButtonsState,
}: HfDynamicFieldComponentProps<DropDownResult | DropDownNoSelection> & TrainingFieldProps) {
  return (
    <OdinController
      name={name as string}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { ref: fieldRef, onChange, value }, fieldState: { error } }) => (
        <TrainingField
          label={label}
          value={value}
          readOnly={readOnly}
          required={required}
          onChange={onChange}
          error={error?.message}
          inputRef={fieldRef}
          formId={formId}
          fieldId={id as number}
          setFieldValue={setFieldValue}
          setFormButtonsState={setFormButtonsState}
        />
      )}
    />
  );
}
